<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let index = $index) {
        @if (index == 0) {
          <ng-container [formGroup]="product">
            <ng-container formGroupName="parameters">
              <div class="row">
                <div class="col-md-12 mt">
                  <pr-input-date
                    formControlName="finalDateMission"
                    label="Sélectionnez une date"
                    [derrors]="derrors"
                    [isDefault]="false"
                  >
                  </pr-input-date>
                </div>
              </div>
            </ng-container>
          </ng-container>
        }
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
